import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  NotBlankString__toString_impl_5tex9r2ig2s5isyc5ve as NotBlankString__toString_impl_5tex9r,
  NotBlankString__hashCode_impl_fxqzj41ooh7w2aare6h as NotBlankString__hashCode_impl_fxqzj4,
} from '../../../../../../types-types/kotools/types/text/NotBlankString.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var UserIdClass;
function UserId() {
  if (UserIdClass === VOID) {
    class $ {
      constructor(value) {
        this.e2f_1 = value;
      }
      toString() {
        return 'UserId(value=' + NotBlankString__toString_impl_5tex9r(this.e2f_1) + ')';
      }
      hashCode() {
        return NotBlankString__hashCode_impl_fxqzj4(this.e2f_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof UserId()))
          return false;
        if (!(this.e2f_1 === other.e2f_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'UserId');
    UserIdClass = $;
  }
  return UserIdClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  UserId as UserId1bjlkq3ivhppd,
};
//endregion

//# sourceMappingURL=UserId.mjs.map
